import { Instagram, Facebook, Youtube, Linkedin, Mail } from "lucide-react";
import { SOCIALS, ASSETS } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-[#050d1c] text-white/70 py-14 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <span
            className="block h-12 w-[220px]"
            style={{
              backgroundImage: `url(${ASSETS.logo})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "152% auto",
              filter: "invert(1)",
            }}
            role="img"
            aria-label="CDaught Speaks"
          />
          <p className="mt-5 text-[14px] max-w-sm leading-relaxed">
            Cultivating Environments Conducive to Growth — for schools, students, educators,
            families, and communities.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <Social href={SOCIALS.instagram} icon={Instagram} label="Instagram" testid="footer-instagram" />
            <Social href={SOCIALS.facebook} icon={Facebook} label="Facebook" testid="footer-facebook" />
            <Social href={SOCIALS.youtube} icon={Youtube} label="YouTube" testid="footer-youtube" />
            <Social href={SOCIALS.linkedin} icon={Linkedin} label="LinkedIn" testid="footer-linkedin" />
            <Social href={`mailto:${SOCIALS.email}`} icon={Mail} label="Email" testid="footer-email" />
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow text-gold">Explore</div>
          <ul className="mt-4 space-y-2 text-[14px]">
            {["outcomes","framework","services","about","voices","contact"].map(id => (
              <li key={id}>
                <a
                  href={`#${id}`}
                  data-testid={`footer-link-${id}`}
                  className="hover:text-gold transition-colors capitalize"
                >
                  {id}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow text-gold">Get In Touch</div>
          <ul className="mt-4 space-y-2 text-[14px]">
            <li>
              <a href={`mailto:${SOCIALS.email}`} className="hover:text-gold transition-colors">
                {SOCIALS.email}
              </a>
            </li>
            <li className="text-white/55">CDaught Speaks LLC</li>
            <li className="text-white/55">Available nationwide</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-2 justify-between text-[12px] text-white/40">
        <div>© {new Date().getFullYear()} CDaught Speaks LLC. All rights reserved.</div>
        <div className="italic font-serif text-white/55">Cultivating Environments Conducive to Growth.</div>
      </div>
    </footer>
  );
}

function Social({ href, icon: Icon, label, testid }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-testid={testid}
      className="w-10 h-10 border border-white/15 rounded-full flex items-center justify-center hover:border-gold hover:text-gold transition-colors"
    >
      <Icon size={16} />
    </a>
  );
}
